<template>
    <div class="new-level-form-container">
		<div class="tw-flex tw-items-center tw-justify-between">
			<h2 class="new-level-title"
				:style="`color:${$appColors.info}`"
			>Nuevo Nivel</h2>
			<v-btn color="primary btn-action mr-4" @click="$emit('return-page')">
				<img
					:src="`${$imageUrl}/btn-right-arrow.webp`"
					alt="Atrás"
					class="mr-4"
				/>
				Atrás
			</v-btn>
		</div>
		<form>
			<label for="new-tool-name" class="name-input"
				:style="`color:${$appColors.info}`"
			>
				Nombre
				<input
					class="new-survey-input" 
					placeholder="Nombre"
					v-model="level.name"
				/>
			</label>
			<label for="new-tool-name" class="name-input"
				:style="`color:${$appColors.info}`"
			>
				Tipo
				<MultiSelect
					clearable
					item-divider
					ref="multiselect"
					min-height="32px"
					class="type-input new-survey-input"
					transition-name="vertical"
					:prop="levelPropName"
					:style="`color:${$appColors.info}`"
					:options="levels"
					:value="levelSelected"
					@input="selecting"
				>
					<template slot="tag" slot-scope="{ tag }">
						<span>{{tag[levelPropName]}}</span>
					</template>
					<template slot="icon">
						<div class="menu-icon"
							:style="`border-top:7px solid ${$appColors.success}`"
						></div>
					</template>
					<template slot="menu" slot-scope="{ menuItem, selected, indexItem }">
						<div
							:class="[
								'menu-item',
								{ 'menu-item-selected': selected },
							]"
							:style="`background-color:${selected ? $appColors.primary : 'transparent'}`"
						>
							<span
								class="menu-item-name">{{menuItem[levelPropName]}}</span>
							<span
								v-if="indexItem === 0"
								class="menu-add"
								:style="`color:${selected ? 'white' : $appColors.primary}`"
							>+</span>
							<span v-else class="menu-index"
								:style="`color:${selected ? 'white' : $appColors.primary}`"
							>{{menuItem.number}}</span>
						</div>
					</template>
				</MultiSelect>
			</label>
			<div class="buttons-wrapper">
				<v-checkbox
					hide-details
					class="question-check"
					label="Es pregunta"
					color="success"
					v-model="level.flagQuestion"
				></v-checkbox>
				<app-button
					class="btn-tool"
					icon="add"
					:style="`background-color:${$appColors.primary}`"
					@click="createLevel"
				/>
				<app-tooltip-button
					v-if="!disabledView"
					icon="remove_red_eye"
					size="24"
					text="Ver Árbol de Praktiko"
					color="primary"
					@click-icon="$emit('view-hierarchy')"
				/>
			</div>
		</form>
    </div>
</template>
<script>
import MultiSelect from 'multiselect-dl';
import appButton from '@/components/shared/app-button';
import { mapGetters } from 'vuex';

function created() {
	const { toolCode } = this.$route.params;
	this.$store.dispatch('levelType/load', toolCode);
}

function selecting([levelSelected]) {
	this.levelSelected = [levelSelected];
	if (levelSelected[this.levelPropName] === 'Nuevo tipo') {
		this.$refs.multiselect.toogleMenu();
		this.goTo('new-type-form');
		this.levelSelected = [];
	}
}

async function createLevel() {
	const body = this.buildBody();
	try {
		await this.$store.dispatch('tool/createLevel', body);
		this.showNotification(
			`El nivel: "${this.level.name}", fue creado con éxito`,
			'success',
		);
		this.cleanForm();
	} catch (error) {
		this.showGenericError();
	}
}

function cleanForm() {
	this.level = {
		name: '',
		type: '',
		flagQuestion: true,
	};
}

function buildBody() {
	const { toolCode } = this.$route.params;
	const body = {
		toolCode,
		hierarchyFatherId: 0,
		data: [{
			flagQuestion: Number(this.level.flagQuestion),
			name: this.level.name,
			number: this.levelSelected[0].number,
		}],
	};
	return body;
}

function data() {
	return {
		level: {
			name: '',
			type: '',
			flagQuestion: true,
		},
		levelPropName: 'name',
		levelSelected: [],
	};
}

export default {
	name: 'tool-new-level',
	components: {
		appButton,
		MultiSelect,
	},
	computed: {
		...mapGetters('levelType', [
			'levels',
		]),
	},
	created,
	data,
	methods: {
		buildBody,
		cleanForm,
		createLevel,
		selecting,
	},
	props: {
		disabledView: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
.new-level-form-container {
	background-color: white;
	margin-bottom: 20px;
	padding: 20px 0 40px 15px;

	.new-level-title {
		font-family: font(bold);
		font-size: size(xlarge);
		margin-bottom: 20px;
	}

	form {
		align-items: flex-end;
		display: flex;

		.name-input, .type-input {
			flex: 1 1 10%;
			font-family: font(regular);
			font-size: size(small);
			margin-right: 20px;
		}

		.type-input {
			align-items: center;
			display: flex;
			justify-content: space-between;

			.menu-icon {
				border-left: 5px solid transparent;
				border-right: 5px solid transparent;
				height: 0;
				width: 0;
			}

			.menu-item {
				align-items: center;
				cursor: pointer;
				display: flex;
				height: 45px;
				justify-content: space-between;
				font-family: font(bold);
				padding: 0 12px;
				transition: transform 150ms ease-in-out;
			}

			.menu-item-selected {
				color: white;

				.menu-index {
					color: white;
				}
			}

			.menu-item:hover {
				transform: translateX(5px);

				.menu-add, .menu-index {
					color: white;
				}
			}

			.menu-add {
				font-size: size(big);
			}

			.menu-index {
				margin-right: 5px;
			}

		}

		.btn-tool {
			border-radius: 4px;
			color: white;
			font-family: font(bold);
			height: 34px;
			margin: 0 10px;
			padding: 5px 10px;
		}

		.buttons-wrapper {
			align-items: center;
			display: flex;
			flex: 1 1 auto;

			.question-check {
				flex: 0 0 35%;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/tools/tool-new-level.vue